import { appendable } from "@tblabs/truffle/Core/appendable";
import { TableViewer } from "./TableViewer";


export class TableViewerColumn<T>
{
    constructor(
        public Header: appendable[],
        public Mapping: (
            record: T,
            cell: appendable,
            row: appendable,
            table: TableViewer<T>) => appendable | appendable[],
        public AddWhen?: (record: T) => boolean) { }
}
